export default "__VITE_ASSET__CqfQtwNd__"